import { useEffect, useState } from 'react';

/** Phone-sized screens (and a project frame that narrow) get the mobile layout. */
const QUERY = '(max-width: 760px)';

export function isMobileNow(): boolean {
  return typeof window !== 'undefined' && window.matchMedia?.(QUERY).matches === true;
}

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(isMobileNow);
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return;
    const changed = () => setMobile(media.matches);
    changed();
    media.addEventListener('change', changed);
    return () => media.removeEventListener('change', changed);
  }, []);
  return mobile;
}

/** A touch-first device (phones, tablets): play goes fullscreen on its own. */
export function isTouchDevice(): boolean {
  return typeof window !== 'undefined' && (window.matchMedia?.('(pointer: coarse)').matches === true || navigator.maxTouchPoints > 0);
}
